import { useContext } from "react";
import { AuthContext } from "@/contexts/Auth";
import { useQueryClient } from "@tanstack/react-query";

export const useAuth = () => {
  const { workspace, setWorkspace } = useContext(AuthContext);
  const client = useQueryClient();

  const properlySetWorkspace = (workspaceId: string) => {
    client.invalidateQueries();

    if (workspaceId !== workspace) {
      setWorkspace(workspaceId);
    }
  };

  return { workspace, setWorkspace: properlySetWorkspace };
};
